import { Proveedor } from './proveedor';
import { Comunidad, TipoMaterialDto, Estado, MaterialDto, RubroContable, Usuario } from ".";
import { FormControl, FormGroup } from '@angular/forms';

export class Pedido {

  constructor(
    public readonly Id: number,
    public readonly ComunidadOrigenId: number,
    public readonly ComunidadOrigen: Comunidad,
    public readonly ComunidadDestinoId: number,
    public readonly ComunidadDestino: Comunidad,
    public readonly TipoMaterialId: number,
    public readonly TipoMaterial: TipoMaterialDto,
    public readonly Observacion: string | null,
    public readonly EstadoId: number,
    public readonly Estado: Estado,
    public readonly Activo: boolean,
    public PedidoItems: PedidoItem[],
    public readonly PedidoHistorial: PedidoHistorial[],
    public TieneFechaPorVencer?: boolean,
    public TieneObservacion?: boolean

  ) {}
}

export class PedidoDashboard {
  constructor(
    public readonly PedidoId: number,
    public readonly ComunidadDestinoId: number,
    public readonly ComunidadDestinoNombre: string | null,
    public readonly MaterialNombre: string | null,
    public readonly FechaNecesidad: Date,
    public readonly FechaLimite: Date,
  ) {}
}

export class PedidoItem {
  constructor(
    public readonly Id: number,
    public readonly PedidoId: number,
    public readonly Pedido: Pedido,
    public readonly MaterialId: number,
    public readonly Material: MaterialDto,
    public readonly Cantidad: number,
    public readonly CantidadRecibida: number,
    public readonly FechaNecesidad: Date,
    public readonly FechaEntregaPlanificada: Date,
    public readonly FechaLimite: Date,
    public readonly Detalle: string | null,
    public readonly RubroContableId: number,
    public readonly RubroContable: RubroContable,
    public readonly Observacion: string | null,
    public readonly Activo: boolean,
  ) {}
}

export class PedidoDto {
  constructor(
    public readonly Id: number,
    public readonly ComunidadOrigenId: number | null,
    public readonly ComunidadOrigenNombre: string | null,
    public readonly ComunidadDestinoId: number | null,
    public readonly ComunidadDestinoNombre: string | null,
    public TipoMaterialId: number | null,
    public TipoMaterialNombre: string | null,
    public PedidoComunidadRolAprobador: number | null,
    public PedidoComunidadRol: string | null,
    public readonly Observacion: string | null,
    public readonly EstadoId: number | null,
    public readonly EstadoNombre: string | null,
    public PedidoItems: PedidoItemDto[],
    public readonly PedidoHistorial: PedidoHistorialDto[],
    public readonly PedidoPresupuesto: PedidoPresupuesto[],
    public readonly Activo: boolean,
    public Pagado: boolean,
    public Adjuntos: PedidoAdjunto[],
    public TieneFechaPorVencer?: boolean,
    public TieneObservacion?: boolean
  ) {}
}

export class UploadPedidoAttachResponseDto {
  constructor (
      public readonly Archivos: PedidoAdjunto[]
  ) {}
}

export class PedidoAdjunto {
  constructor (
      public readonly Id: number,
      public Descripcion: string | null,
      public readonly NombreDocumento: string | null,
      public readonly UrlDocumento: string | null,
      public readonly ComunidadId: number
  ) {}
}

export class PedidoItemDto {
  constructor(
    public readonly Id: number,
    public PedidoId: number,
    public readonly MaterialId: number,
    public readonly MaterialNombre: string | null,
    public readonly MaterialUnidadMedida: string | null,
    public readonly Cantidad: number,
    public readonly FechaNecesidad: Date,
    public readonly FechaLimite: Date,
    public readonly RubroContableId: number,
    public readonly RubroContableNombre: string | null,
    public readonly ComunidadOrigenId: number,
    public readonly ComunidadOrigenNombre: string | null,
    public readonly ComunidadDestinoId: number,
    public readonly ComunidadDestinoNombre: string | null,
    public readonly Observacion: string | null,
    public readonly Detalle: string | null,
    // public readonly FechaEntrega: Date,
    public readonly FechaEntregaReal: Date,
    public FechaEntregaPlanificada: Date,
    public ProveedorId: number,
    public ProveedorNombre: string | null,
    public MonedaId: number,
    public readonly MonedaNombre: string | null,
    public Monto: number,
    public readonly Activo: boolean
  ) {}
}

export class ModalPedidoItemDto {
  constructor(
    public readonly MaterialId: number,
    public readonly PedidoId: number,
    public readonly PedidoItemDto: PedidoItemDto | null,
    public readonly CanEditMaterial: boolean,
    public readonly TipoMaterialId: number | null,
    public readonly TipoMaterialNombre: string | null,
    public readonly EstadoId?: number,
    public readonly ComunidadOrigenId?: number,
    public readonly ComunidadDestinoId? : number,
    public readonly Observacion?: string | null,
    public readonly Pagado?: boolean
  ) {}
}

export class ModalPedidoItemsDto {
  constructor(
    public readonly PedidoDto: PedidoDto,
    public readonly CanEditMaterial: boolean,
    public readonly Mode?: string
  ) {}
}

export class DialogAgregarPresupuesto {
  constructor(
    public readonly PresupuestoId: number,
    public readonly PedidoId: number,
    public readonly PedidoItems: PedidoItemDto[],
    public readonly PedidoTipoMaterialId: number,
    public readonly CanEditPresupuesto: boolean,
    public readonly CanSelectPresupuesto: boolean,
    public readonly PrecargaPedidoItemId?:number
  ) {}
}

/* Historial*/
export class PedidoHistorial {
  constructor(
    public readonly Id: number,
    public readonly PedidoId: number,
    public readonly Pedido: Pedido,
    public readonly Descripcion: string | null,
    public readonly Observacion: string | null,
    public readonly UsuarioCreacionId: number,
    public readonly Usuario: Usuario,
    public readonly UsuarioCreacion: string | null,
    public readonly UsuarioModificacion: string | null,
    public readonly FechaCreacion: Date,
    public readonly FechaModificacion: Date,
    public readonly PedidoComunidadRolId ? : number,
  ) {}
}

export class PedidoHistorialDto {
  constructor(
    public readonly PedidoId: number,
    public readonly Pedido: Pedido,
    public readonly Descripcion: string | null,
    public readonly Observacion: string | null,
    public readonly UsuarioCreacionId: number,
    public readonly Usuario: Usuario,
    public readonly UsuarioCreacion: string | null,
    public readonly UsuarioModificacion: string | null,
    public readonly FechaCreacion: Date,
    public readonly FechaModificacion: Date,
    public readonly PedidoComunidadRolIdNombre: string | null,
    public readonly PedidoComunidadRolId ? : number,
  ) {}
}

export class SearchPedidoRequestDto {
  constructor(
      public readonly PageSize: number | null,
      public readonly PageNumber: number | null,
      public readonly OrderAscending: boolean | null,
      public readonly OrderFieldName: string | null,
      public PedidoId: number | null,
      public ComunidadOrigenId: number | null,
      public ComunidadDestinoId: number | null,
      public Estados: string | null,
      public TipoMaterialId: number | null ,
      public VerSoloActivos: boolean,
      public FiltroFacturado: number | null,
      public VerSoloMisPendientesAprobacion: boolean | null,
      public RolId: number | null,
  ){}
}

export class SearchPedidoResponse {
  constructor(
    public readonly count: number,
    public readonly result: Pedido[]
  ) {}
}

/** PedidoPresupuestos */
export class PedidoRecepcionItem {
    constructor(
      public readonly Id: number,
      public PedidoId: number,
      public readonly MaterialId: number,
      public readonly MaterialNombre: string | null,
      public readonly MaterialUnidadMedida: string | null,
      public readonly Detalle: string | null,
      public readonly Cantidad: number,
      public readonly ProveedorId: number,
      public readonly ProveedorNombre: string | null,
      public readonly FechaEntregaPlanificada: Date,
      public readonly FechaEntregaReal: Date,
      public readonly RecibioPedido: boolean,
      public readonly EntregaParcial: boolean,
      public readonly CantidadRecibida: number,
      public readonly Observacion: string | null,
      public readonly Activo: boolean,
    ) {}
  }

  export class PedidoPresupuesto {
    constructor(
      public Id: number,
      public readonly Monto: number | null,
      public readonly PedidoId: number,
      public readonly ProveedorId: number | null,
      public readonly Proveedor: Proveedor | null,
      public readonly ProveedorNombre: string | null,
      public readonly MonedaId: number,
      public readonly MonedaNombre: string | null,
      public PresupuestoUrl: string | null,
      public readonly FechaVigencia: Date | null,
      public readonly PresupuestoBase64: string | null,
      public readonly PresupuestoExtension: string | null,
      public readonly Observacion: string | null,
      // public readonly FechaEntrega: Date,
      public readonly TipoCompraNombre: string | null,
      public readonly Activo: boolean,
      public readonly AlicuotaIvaId: number | null,
      public readonly AlicuotaIvaNombre: string | null,
      public IncluyeFlete: boolean,
      public PresupuestoDetalle: PedidoPresupuestoDetalle[],
      public FormasPago: PedidoPresupuestoFormaPago[]
    ) {}
  }

  export class PedidoPresupuestoDetalle {
    constructor(
      public readonly Id: number,
      public readonly PedidoPresupuestoId: number,
      public PedidoItemId: number,
      public readonly PedidoItemMaterial: string | null,
      public MonedaId: number,
      public readonly MonedaNombre: string | null,
      public MontoUnitario: number,
      public Cantidad: number,
      public Detalle: string | null,
      public Total: number,
      public EsVariante: boolean,
      public MaterialId: number | null,
      public MaterialNombre: string | null,
      public Seleccionado: boolean,
      public MaterialFormGroup: FormGroup | null,
      public IsMaterialAutoSearching: boolean
    ) {}
  }

  export class PedidoPresupuestoFormaPago {
    constructor(
      public readonly Id: number,
      public readonly PedidoPresupuestoId: number,
      public FormaPagoId: number,
      public readonly FormaPagoNombre: string
    ) {}
  }

export class SavePedidoPresupuesto {
  constructor(
    public readonly Id: number | null,
    public readonly PedidoId: number | null,
    public readonly MonedaId: number | null,
    public readonly TipoCompra: number | null,
    public readonly ProveedorId: number | null,
    public readonly Monto: number | null,
    public readonly Observacion: string | null,
    public readonly PresupuestoDetalle: PedidoPresupuestoDetalle[],
    public FormasPago: PedidoPresupuestoFormaPago[],
    public Proveedor: Proveedor | null,
    public readonly AlicuotaIvaId: number | null,
    public IncluyeFlete: boolean,
    public Activo: boolean,
    public PresupuestoBase64: string | null,
    public PresupuestoExtension: string
  ) {}
}

export class SearchPedidoPresupuestoRequestDto {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public VerSoloActivos: boolean,
    public readonly PedidoId: number,
  ) {}
}

export class SearchPedidoPresupuestoResponse {
  constructor(
    public readonly count: number,
    public readonly result: PedidoPresupuesto[]
  ) {}
}

export class PedidoPermisosDto {
  constructor(
    public CanEdit: boolean,
    public CanDelete: boolean,
    public CanApprove: boolean,
    public CanPlanificar: boolean,
    public CanPlanificarEditar: boolean,
    public CanComentar: boolean,

    public CanMaterialVer: boolean,
    public CanAddMaterial: boolean,
    public CanEditMaterial: boolean,
    public CanDeleteMaterial: boolean,

    public CanPresupuestoVer: boolean,
    public CanAddPresupuesto: boolean,
    public CanEditPresupuesto: boolean,
    public CanDeletePresupuesto: boolean,
    public CanSelectPresupuesto: boolean,

    public CanRemitoVer: boolean,
    public CanAddRemito: boolean,
    public CanEditRemito: boolean,
    public CanDeleteRemito: boolean,

    public ShowBotonEnviarPresupuestar: boolean,
    public ShowBotonEnviarRevision: boolean,
    public ShowBotonEnviarPendienteEntrega: boolean,
    public ShowBotonEnviarPendienteCoordinacion: boolean,
    public ShowBotonEnviarEntregado: boolean,
    public ShowBotonEnviarFinalizado: boolean,
    public ShowBotonCrearIncidente: boolean
  ) {}
}

export class DialogEditarMaterial {
  constructor(
    public readonly MaterialId: number,
    public readonly PedidoId: number,
    public readonly PedidoItems: PedidoItemDto[],
    public readonly canEditMaterial: boolean,
  ) {}
}

export class PedidoMaterial {
  constructor(
    public Id: number,
    public readonly PedidoId: number,
    public readonly ProveedorId: number,
    public readonly Proveedor: Proveedor,
    public readonly Material: MaterialDto,
    public readonly ProveedorNombre: string | null,
    public readonly MaterialNombre: string | null,
    public readonly PedidoItemDto: PedidoItemDto,
    public readonly Observacion: string | null,
    public readonly Activo: boolean,
  ) {}
}


export class PedidoEstadoChangeDto {
  constructor(
    public readonly PedidoId: number,
  ) {}
}

export class AprobarPedidoDto {
  constructor(
    public readonly Id: number,
    public readonly EsRechazo: boolean,
    public readonly Observacion: string
  ) {}
}

export class BajaMasivaPedidosDto {
  constructor(
    public readonly Id: number[]
  ) {}
}

export class PedidoValidationResponseDto
{
    public readonly PedidoId: number
    public readonly IsValid: number
    public readonly Observacion: string
}

export class DarBajaPedidosResponseDto
{
  public readonly Pedidos: PedidoValidationResponseDto[]
  public readonly Count: number
  public readonly TotalOk: number
}

export class SavePedidoPresupuestoSeleccion {
  constructor(
    public readonly PedidoId: number,
    public readonly ProveedorId: number | null,
    public readonly PresupuestoDetalleIdList: number[]
  ) {}
}

export class PresupuestoDetallesByPedidoDto {
  constructor(
    public readonly Presupuestos: PedidoPresupuesto[],
    public readonly PresupuestosDetalles: PedidoPresupuestoDetalle[]
  ) {}
}

export class SearchPedidoItemRequestDto {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly TipoMaterialId: number,
    public readonly PedidoId: number,
    public readonly ComunidadOrigenId: number,
    public readonly ComunidadDestinoId: number,
    public readonly EstadoId: number,
    public readonly ProveedorId: number,
    public readonly MaterialId: number,
    public readonly FechaEntregaPlanificadaDesde: Date,
    public readonly FechaEntregaPlanificadaHasta: Date,
    public readonly RubroContableId: number,
    public readonly Estados: number,
    public readonly VerSoloMisPendientesAprobacion: number,
    public readonly FiltroFacturado: number,
    public readonly RolId: number,
  ) {}
}

export class SearchPedidoItemResponse {
  constructor(
    public readonly count: number,
    public readonly result: PedidoItemDto[]
  ) {}
}

export class SavePedidoHistorialDto {
  constructor(
    public readonly Id: number,
    public readonly PedidoId: number | null,
    public readonly Descripcion: string | null,
    public readonly Observacion: string
  ) {}
}

export class PedidoEntregasResponseDto {
  constructor(
    public readonly HayPendientesEntrega: boolean,
    public readonly Materiales: PedidoEntregasItemDto[],
    public readonly AgrupadoProveedores: PedidoEntregasAgrupadoItemDto[],
    public readonly AgrupadoMateriales: PedidoEntregasAgrupadoItemDto[]
  ) {}
}

export class PedidoEntregasItemDto {
  constructor(
    public readonly ProveedorId: number,
    public readonly ProveedorNombre: string | null,
    public readonly MaterialId: number,
    public readonly MaterialNombre: string | null,
    public readonly MaterialUnidadMedida: string | null,
    public readonly CantidadPedida: number,
    public readonly CantidadEntregada: number,
    public readonly Diferencia: number
  ) {}
}

export class PedidoEntregasAgrupadoItemDto {
  constructor(
    public readonly PedidoItemId: number,
    public readonly ProveedorNombre: string | null,
    public readonly MaterialNombre: string | null,
    public readonly CantidadPedida: number,
    public readonly CantidadEntregada: number,
    public readonly Diferencia: number
  ) {}
}

export class PedidoRemito {
  constructor(
    public readonly Id: number | null,
    public readonly Codigo: string | null,
    public readonly ProveedorId: number | null,
    public readonly ProveedorNombre: string | null,
    public RemitoUrl: string | null,
    public readonly Observacion: string | null,
    public readonly FechaEntrega: Date | null,
    public RemitoDetalle: PedidoRemitoDetalle[]
  ) {}
}

export class PedidoRemitoDetalle {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string | null,
    public readonly PedidoRemitoId: number,
    public readonly PedidoItemId: number,
    public readonly PedidoId: number,
    public readonly ProveedorId: number,
    public readonly ProveedorNombre: string | null,
    public readonly ComunidadDestinoNombre: string | null,
    public readonly FechaEntrega: Date,
    public readonly MaterialId: number,
    public readonly MaterialNombre: string | null,
    public readonly MaterialUnidadMedidaNombre: string | null,
    public readonly Detalle: string | null,
    public readonly CantidadSolicitada: number,
    public Cantidad: number,
    public RemitoUrl: string
  ) {}
}

export class RemitoDetallesByPedidoDto {
  constructor(
    public readonly Remitos: PedidoRemito[],
    public readonly RemitosDetalles: PedidoRemitoDetalle[]
  ) {}
}

export class SaveRecepcionPedido {
  constructor(
    public readonly RemitoId: number,
    public readonly ProveedorId: number,
    public readonly CantidadRecibida: number,
    public readonly Fecha: Date,
    public  RemitoUrl: string | null,
    public readonly Observacion: string
  ) {}
}

export class SearchPedidoItemsPendientesEntregaRequestDto {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly TipoMaterialId: number,
    public readonly PedidoId: number,
    public readonly ComunidadDestinoId: number,
    public readonly ProveedorId: number,
    public readonly MaterialId: number,
    public readonly FechaEntregaPlanificadaDesde: Date,
    public readonly FechaEntregaPlanificadaHasta: Date
  ) {}
}

export class SearchPedidoItemsPendientesEntregaResponse {
  constructor(
    public readonly count: number,
    public readonly result: SearchPedidoItemsPendientesEntregaItemDto[]
  ) {}
}

export class SearchPedidoItemsPendientesEntregaItemDto {
  constructor(
    public readonly Id: number,
    public PedidoId: number,
    public readonly MaterialId: number,
    public readonly MaterialNombre: string | null,
    public readonly MaterialUnidadMedida: string | null,
    public readonly Cantidad: number,
    public readonly ComunidadDestinoId: number,
    public readonly ComunidadDestinoNombre: string | null,
    public readonly Detalle: string | null,
    public readonly FechaEntrega: Date,
    public FechaEntregaPlanificada: Date,
    public readonly ProveedorId: number,
    public readonly ProveedorNombre: string
  ) {}
}

export class SearchReporteEntregaRequestDto {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public FechaEntrega: string | null,
    public Codigo: number | null,
    public MaterialNombre: string | null,
    public Detalle: string | null,
    public Cantidad: number | null,
    public MaterialUnidadMedida: string | null,
  ) { }
}

export class PedidoComunidadRolDto {
  constructor(
    public Id: number,
    public Nombre: string
  ) { }
}

export class DialogAgregarComparativa {
  constructor(
    public readonly PedidoId: number,
    public readonly PedidoItems: PedidoItemDto[],
    public readonly PedidoTipoMaterialId: number,
    public readonly CanEditPresupuesto: boolean,
    public readonly CanSelectPresupuesto: boolean
  ) { }
}

export class SearchReporteEstadoCuentasRequestDto {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public PersonaDocumento: string | null,
    public PersonaNombre: string | null,
    public PersonaApellido: string | null,
    public Saldo: number,
    public SaldoVencido: number,
    public MonedaId: number,
    public ProveedorId: number,
    public ComunidadId: number,
    public ConsorcioId: number,
    public UnidadFuncionalId: number
  ) { }
}

export class SavePedidoPlanificacionDto {
  constructor(
    public readonly PedidoId: number,
    public readonly Items: SavePedidoPlanificacionItemDto[]
  ) {}
}

export class SavePedidoPlanificacionItemDto {
  constructor(
    public readonly Id: number,
    public readonly MaterialNombre: string | null,
    public readonly Detalle: string | null,
    public readonly Cantidad: number,
    public readonly MaterialUnidadMedida: string | null,
    public FechaEntregaPlanificada: string | null,
    public ProveedorId: number,
    public ProveedorNombre: string | null,
    public MonedaId: number,
    public MonedaNombre: string | null,
    public Monto: number,
    public ProveedorPlanificacionFormControl: FormControl | null,
    public IsProveedorPlanificacionAutoSearching: boolean,
    public FilteredProveedorPlanificacionList: Proveedor[],
  ) {}
}
